import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { ReactComponent as LeftArrow } from '../../assets/left_arrow.svg';
import { All } from '../../reducers/store';
import BackButtonContext from '../../scenes/BackButtonContext';
import { onKeyPress } from '../../utils/keypress';

import styles from './index.module.css';

interface StateProps {
  isHeaderHidden: boolean;
}

interface Props extends StateProps {
  onClick?: () => void;
}

const BackComponent = ({ isHeaderHidden, onClick }: Props) => {
  const { t } = useTranslation();
  const { isBackButtonShown } = useContext(BackButtonContext);

  const handleClick = () => {
    if (onClick) return onClick();
    if (history.location.search.indexOf('part=1') === -1) {
      history.goBack();
    } else {
      // Documents route does /[authCode]]/[formSetId]/_documents?page=1 then /[authCode]]/[formSetId]/_documents?page=1&part=1
      const previousPath = history.location.pathname
        .split('/')
        .slice(0, -2)
        .join('/');
      history.push(previousPath);
    }
  };

  const history = useHistory();
  if (isHeaderHidden || !isBackButtonShown) {
    return <></>;
  }

  return (
    <LeftArrow
      role="button"
      aria-label={t('Back')}
      tabIndex={0}
      viewBox="0 0 12 12"
      data-testid={'back-button'}
      onKeyDown={(e) =>
        onKeyPress({
          e,
          onConfirm: () => handleClick(),
        })
      }
      className={styles.Back}
      onClick={handleClick}
    />
  );
};

const mapStateToProps = (store: All): StateProps => ({
  isHeaderHidden: store.isHeaderHidden,
});

const Back = connect(mapStateToProps)(BackComponent);

export default Back;
